import * as tslib_1 from "tslib";
import { ViewContainerRef } from '@angular/core';
import { ESRI } from '../../../../esri-loader-util';
import { LayerService } from '../../../../services/layer.service';
import { BaseSymbolEditorComponent } from '../../symbol-editor/baseSymbolEditor';
var MarkerSymbol;
var PictureSymbol;
var PointSymbolEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PointSymbolEditorComponent, _super);
    function PointSymbolEditorComponent(_vcr, layerService) {
        var _this = _super.call(this, _vcr, layerService) || this;
        _this.layerService = layerService;
        _this.colorProperties = ['symbolColor, outlineColor'];
        _this.sizeOptions = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 30, 32, 36, 40, 50, 64, 72, 100, 128];
        // TODO: Implement custom PNG and previews for non-path styles
        _this.pointSymbolOptions = {
            pointStyles: [
                {
                    name: 'Circle',
                    type: 'simplemarkersymbol',
                    value: 'circle'
                },
                {
                    name: 'Square',
                    type: 'simplemarkersymbol',
                    value: 'square'
                },
                {
                    name: 'Cross',
                    type: 'simplemarkersymbol',
                    value: 'cross'
                },
                {
                    name: 'Diamond',
                    type: 'simplemarkersymbol',
                    value: 'diamond'
                },
                {
                    name: 'X',
                    type: 'simplemarkersymbol',
                    value: 'x'
                },
                {
                    name: 'Triangle',
                    type: 'simplemarkersymbol',
                    value: 'triangle'
                } //,
                //{
                //    name: 'Custom Base64 PNG',
                //    type: 'picturemarkersymbol',
                //    json: {
                //        angle: 0,
                //        xoffset: 0,
                //        yoffset: 0,
                //        type: 'esriPMS',
                //        imageData: '',
                //        contentType: 'image/png',
                //        width: 24,
                //        height: 24
                //    }
                //}
            ]
        };
        _this.applyChange = function () {
            if (_this.markerSymbol) {
                if (_this.markerSymbol.outline) {
                    _this.markerSymbol.outline.color.setColor(_this.outlineColor);
                }
                var markerProperties = {
                    angle: _this.markerSymbol.angle,
                    color: _this.symbolColor,
                    outline: _this.markerSymbol.outline.clone(),
                    size: _this.pointSize,
                    style: _this.pointStyle.value,
                    xoffset: _this.markerSymbol.xoffset,
                    yoffset: _this.markerSymbol.yoffset
                };
                if (_this.pointStyle.path) {
                    markerProperties.path = _this.pointStyle.path;
                }
                _this.layerSymbol = new MarkerSymbol(markerProperties);
            }
            else if (_this.pictureSymbol) {
                _this.layerSymbol = new PictureSymbol({
                    angle: _this.pictureSymbol.angle,
                    color: _this.pictureSymbol.color.clone(),
                    height: _this.pictureSymbol.height,
                    url: _this.pictureUrl,
                    width: _this.pictureSymbol.width,
                    xoffset: _this.pictureSymbol.xoffset,
                    yoffset: _this.pictureSymbol.yoffset
                });
            }
            window.dispatchEvent(new CustomEvent('symbolChange', { detail: _this.uniqueLayerId }));
            return _this.layerSymbol;
        };
        _this.loadESRI();
        return _this;
    }
    PointSymbolEditorComponent.prototype.loadESRI = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.SimpleMarker, ESRI.PictureMarker])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), MarkerSymbol = _a[0], PictureSymbol = _a[1];
                        return [2 /*return*/];
                }
            });
        });
    };
    PointSymbolEditorComponent.prototype.bindForm = function () {
        var _this = this;
        if (this.layerSymbol) {
            if (this.layerSymbol.type === 'picture-marker') {
                this.pictureSymbol = this.layerSymbol;
                this.layerService.fixPictureSymbols([this.pictureSymbol]);
                this.pictureUrl = this.pictureSymbol.url;
            }
            else {
                this.markerSymbol = this.layerSymbol;
                if (this.markerSymbol.path) {
                    this.pointStyle = this.pointSymbolOptions.pointStyles.find(function (style) { return style.path === _this.markerSymbol.path; });
                }
                else {
                    this.pointStyle = this.pointSymbolOptions.pointStyles.find(function (style) { return style.value === _this.markerSymbol.style; });
                }
                this.pointSize = this.markerSymbol.size;
                this.symbolColor = "rgba(" + this.markerSymbol.color.toRgba().join(', ') + ")";
                this.originalColor = this.symbolColor;
                if (this.markerSymbol.outline) {
                    this.outlineColor = "rgba(" + this.markerSymbol.outline.color.toRgba().join(', ') + ")";
                    this.originalOutlineColor = this.outlineColor;
                }
            }
        }
    };
    return PointSymbolEditorComponent;
}(BaseSymbolEditorComponent));
export { PointSymbolEditorComponent };
